import { View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { colors } from '@/lib/theme';

/** Plain field fill behind the league's desktop tab navigation. */
export default function FootballFieldTabBarBackground() {
  return <View style={styles.fieldTabBar} />;
}

const styles = StyleSheet.create(() => ({
  fieldTabBar: {
    backgroundColor: colors.ink.field,
    bottom: 0,
    left: 0,
    pointerEvents: 'none',
    position: 'absolute',
    right: 0,
    top: 0,
  },
}));
